import { Link, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from 'react';

import "../../../assets/css/grid.scss";
import "../../../assets/css/style.scss";
import logo from '../../../assets/images/logo.png';
import * as authApis from 'apis/auth';

function PartnerLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    if (token && role === 'partner') {
      navigate('/partner/verify');
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'email') setEmail(value);
    if (name === 'password') setPassword(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError('Please enter the credentials');
      return;
    }
    setError(false);

    try {
      const response = await authApis.login({ email, password });
      const { token, role } = response.data;

      if (token && role === 'partner') {
        localStorage.setItem('token', token);
        localStorage.setItem('role', role);
        navigate('/partner/verify');
        return;
      }

      if (token) {
        await authApis.logout().catch(() => {});
        localStorage.removeItem('token');
        localStorage.removeItem('role');
      }
      setError('Partner account required');
    } catch (err) {
      if (err.response && err.response.status === 401) {
        setError('Invalid email or password');
      } else {
        setError('An unexpected error occurred. Please try again later.');
      }
    }
  };

  return (
    <div className="App">
      <div className="col-lg-100 col-md-100 col-sm-100 full-height pt-40">
        <div className="login pt-40">
          <div className="logo">
            <img src={logo} alt="" />
          </div>
          <div className="login-title">
            <h1>Partner portal</h1>
            <h6>Log in to verify coupons</h6>
          </div>
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-input">
              <label htmlFor="email">Email address</label>
              <input
                type="text"
                placeholder="Email address"
                required
                name="email"
                value={email}
                onChange={handleChange}
              />
            </div>
            <div className="login-input">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                placeholder="Password"
                required
                name="password"
                value={password}
                onChange={handleChange}
              />
            </div>
            {error && <div className="text-bright-red mb-100">{error}</div>}
            <div className="login-input">
              <button type="submit">Sign In</button>
            </div>
          </form>
          <div className="login-footer">
            <Link to="/">Back to home</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartnerLoginPage;
